export enum UserType {
    Unknown = "",
    Regular = "Regular",
    Tournament = "Tournament",
    Institutional = "Institutional"
}

